import DynamicSearchConstant from '@src/CommonComponents/DynamicSearchComponent/constant';
import {
  SET_SELECTED_TAB,
  SET_SEARCH_VALUE,
  SET_SEARCH_OPTION,
  SET_SEARCH_OPTION_BACKUP,
  SET_SELECTED_OPTION,
  SET_HEALTH_SYSTEM_VALUE,
  SET_GENESIS_ID,
  SET_OPTIONS,
  SET_TIN_VALUE,
  SET_TEMPLATE_VALUE,
  SET_SEARCH_TYPE,
  SET_IS_SEARCH_LOADER,
  SET_TOP_SEARCHED_LIST,
  SET_IS_ERROR,
  SET_IS_MESSAGE,
  SET_USER_DETAIL,
} from '@src/middleware/actions/actionTypes';

export interface HomePageState {
  selectedTab: any;
  searchValue: string;
  searchOption: any[];
  searchOptionBackUp: any[];
  selectedOption: any[];
  healthSystemValue: string;
  gensisId: string;
  options: any[];
  tinValue: string;
  templateValue: string;
  searchType: string;
  isSearchLoader: boolean;
  topSearchedList: { HEALTH_SYSTEM: any[]; TAX_ID: any[]; GEO_SEGMENTATION: any[] };
  isError: boolean;
  isMessage: boolean;
  userDetail: { userId: string; userType: string; userName?: string };
}

const initialState: HomePageState = {
  selectedTab: DynamicSearchConstant.TAB_OPTION[0],
  searchValue: '',
  searchOption: [],
  searchOptionBackUp: [],
  selectedOption: [],
  healthSystemValue: '',
  gensisId: '',
  options: [],
  tinValue: '',
  templateValue: '',
  searchType: DynamicSearchConstant.PAYLOAD_PROPS.providerSearchType,
  isSearchLoader: false,
  topSearchedList: { HEALTH_SYSTEM: [], TAX_ID: [], GEO_SEGMENTATION: [] },
  isError: false,
  isMessage: false,
  userDetail: { userId: '', userType: '', userName: '' },
};

const homePageReducer = (
  state = initialState,
  action: { type: string; payload?: any }
): HomePageState => {
  switch (action.type) {
    case SET_SELECTED_TAB:
      return { ...state, selectedTab: action.payload };
    case SET_SEARCH_VALUE:
      return { ...state, searchValue: action.payload };
    case SET_SEARCH_OPTION:
      return { ...state, searchOption: action.payload };
    case SET_SEARCH_OPTION_BACKUP:
      return { ...state, searchOptionBackUp: action.payload };
    case SET_SELECTED_OPTION:
      return { ...state, selectedOption: action.payload };
    case SET_HEALTH_SYSTEM_VALUE:
      return { ...state, healthSystemValue: action.payload };
    case SET_GENESIS_ID:
      return { ...state, gensisId: action.payload };
    case SET_OPTIONS:
      return { ...state, options: action.payload };
    case SET_TIN_VALUE:
      return { ...state, tinValue: action.payload };
    case SET_TEMPLATE_VALUE:
      return { ...state, templateValue: action.payload };
    case SET_SEARCH_TYPE:
      return { ...state, searchType: action.payload };
    case SET_IS_SEARCH_LOADER:
      return { ...state, isSearchLoader: action.payload };
    case SET_TOP_SEARCHED_LIST:
      return { ...state, topSearchedList: action.payload };
    case SET_IS_ERROR:
      return { ...state, isError: action.payload };
    case SET_IS_MESSAGE:
      return { ...state, isMessage: action.payload };
    case SET_USER_DETAIL:
      return { ...state, userDetail: action.payload };
    default:
      return state;
  }
};

export default homePageReducer;
